<template>
  <!-- 用户流转日志 -->
  <div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-select v-model="type" @change="handleTypeChange">
          <el-option :value="undefined" label="全部"></el-option>
          <el-option :value="1" label="抽奖获得"></el-option>
          <el-option :value="2" label="出售"></el-option>
          <el-option :value="3" label="取出"></el-option>
          <el-option :value="4" label="合约"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="query.prize_id"
          placeholder="请输入奖品id"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submit">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="id" label="日志ID" width="100px">
        <template slot-scope="{ row }">
          {{ row.id }}
        </template>
      </el-table-column>
      <el-table-column label="奖品id" width="100px">
        <template slot-scope="{ row }">
          {{ row.prize.id }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="奖品" width="200px">
        <template slot-scope="{ row }">
          <div>
            <img width="80" class="table-image" :src="row.prize.image" alt />
          </div>
          <p>{{ row.prize.name + " | " + row.prize.second_name }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格">
        <template slot-scope="{ row }">
          {{ row.prize.price }}
        </template>
      </el-table-column>
      <el-table-column prop="category_id" label="所属分类">
        <template slot-scope="{ row }">{{
          getCategoryName(row.prize.category_id)
        }}</template>
      </el-table-column>
      <el-table-column prop="status" label="等级">
        <template slot-scope="{ row }">
          <span :style="`color: ${getRankColor(row.prize.rank)};`">{{
            getRank(row.prize.rank)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="数量"></el-table-column>
      <el-table-column prop="type" label="流转类型" width="100px">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.type === 1">抽奖获得</el-tag>
          <el-tag type="info" v-if="row.type === 2">出售</el-tag>
          <el-tag type="" v-if="row.type === 3">取出</el-tag>
          <el-tag type="danger" v-if="row.type === 4">合约</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updated_at"
        label="流转时间"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="400px"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
    ></el-pagination>
  </div>
</template>

<script>
import { getData } from '../../http'
import ranks from '../../utils/ranks'
import { mapState } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1,
      type: undefined,
      query: {
        page: 1,
        prize_id: '',//奖品名称
      },
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    })
  },
  methods: {
    submit() {
      //查询奖品
      this.loading = true
      let params = this.query
      getData(`user_prize_log/${this.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRank(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getTableData() {
      this.loading = true
      getData(`user_prize_log/${this.id}`, { page: this.page, type: this.type })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.page = page
      this.getTableData()
    },
    handleTypeChange() {
      this.page = 1
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
